import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import DocumentsModern from 'src/components/Documents/DocumentsModern';
import LoadState from 'src/components/LoadState/LoadState';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { usePropertyDocumentsAPI } from 'src/pages/Property/Hooks/usePropertyDocumentsAPI';
import { DocumentFormData } from 'src/utils/S3UploadDocumentsUtility';
import {
  UseFaqsNotesDocumentsAPIReturn
} from 'src/SharedCustomHooks/UseFaqsNotesDocumentsAPI/useDocumentsAPI';

interface PropertyDocumentsProps {
  property: {
    propertyId: string;
    name: string;
  };
}

const PropertyDocuments = ({ property }: PropertyDocumentsProps) => {
  const user: any = useSelector(selectAuthenticatedUser);
  const roleName: string = user?.roles?.[0]?.role?.name ?? '';

  const propertyDocumentsAPIOptions: any = {
    propertyId: property.propertyId,
    userId: user.id,
    roleName,
  };

  const {
    documents,
    loadingDocs,
    isSaving,
    fetchDocuments,
    saveDocument,
    deleteDocument,
  }: UseFaqsNotesDocumentsAPIReturn = usePropertyDocumentsAPI(
    propertyDocumentsAPIOptions
  );

  useEffect(() => {
    void fetchDocuments(property.propertyId);
  }, []);

  const onSave = async (document: DocumentFormData): Promise<void> => {
    await saveDocument(document, property.propertyId, user.id);
  };

  const onDeleteDocument = async (document: any): Promise<void> => {
    await deleteDocument(document.id);
  };

  return (
    <DocumentsModern
      documents={documents}
      user={user}
      labelName="Manuals & Documents"
      saving={isSaving}
      loading={loadingDocs}
      onSave={onSave}
      onDeleteDocument={onDeleteDocument}
      groupDocuments
      from="propertyForm"
    />
  );
};

export default PropertyDocuments;
